import { render, staticRenderFns } from "./toggleProductState.vue?vue&type=template&id=edff895a&scoped=true"
import script from "./toggleProductState.vue?vue&type=script&lang=js"
export * from "./toggleProductState.vue?vue&type=script&lang=js"
import style0 from "./toggleProductState.vue?vue&type=style&index=0&id=edff895a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edff895a",
  null
  
)

export default component.exports